import axios from 'axios'

export function request(config) {
    const instance = new axios.create({
        baseURL: '',
        // baseURL: 'http://192.168.0.125:8000',
        timeout: 15000,
        method: "get"
    });

    // 请求拦截器
    instance.interceptors.request.use(config => {
        //拦截后需要将拦截下来的请求数据返回发送
        return config;
    }, err => {
        console.log(err)
    })

    // 相应拦截器
    instance.interceptors.response.use(res => {
        // 拦截后需要将拦截下来处理成的结果返回
        return res
    }, err => {
        console.log(err)
    })

    return instance(config)
}

export function credit_project_download(province, cityvalue, maintypevalue, typevalue, eiatypevalue, mintime, maxtime) {
    return '/hp/credit-projects/download/' + "?province=" + province + "&cityvalue=" + cityvalue + "&maintypevalue=" + maintypevalue + "&typevalue=" + typevalue + "&eiatypevalue=" + eiatypevalue + "&mintime=" + mintime + "&maxtime=" + maxtime

}

export function compile_unit_download(province, cityvalue) {
    return '/hp/compile-units/download/' + "?province=" + province + "&cityvalue=" + cityvalue
}

export function compile_host_download(province, cityvalue) {
    return '/hp/compile-hosts/download/' + "?province=" + province + "&cityvalue=" + cityvalue
}

export function high_yield_host_download(province, cityvalue, recently, search) {
    return '/hp/public-supervision/high-yield-host/download/' + "?area=" + province + "&cityvalue=" + cityvalue + "&recently=" + recently + "&search=" + search
}

export function is_provincial_project_download(province, cityvalue, recently, search) {
    return '/hp/public-supervision/provincial-project/download/' + "?area=" + province + "&cityvalue=" + cityvalue + "&recently=" + recently + "&search=" + search
}

export function discredit_persion_download(discreditable_type, min_date, max_date, search) {
    return '/hp/discredit-persons/download/' + "?discreditable_type=" + discreditable_type + "&min_date=" + min_date + "&max_date=" + max_date + "&search=" + search
}
